export const PARTNER_STATUS_ACTIVE = 1;

export const RESET_ERROR = 'partners/RESET_ERROR';

export const FETCH_PARTNERS = 'partners/FETCH_PARTNERS';
export const FETCH_PARTNERS_SUCCESS = 'partners/FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAIL = 'partners/FETCH_PARTNERS_FAIL';
export const FETCH_PARTNER_SUCCESS = 'partners/FETCH_PARTNER_SUCCESS';
export const FETCH_PARTNER_FAIL = 'partners/FETCH_PARTNER_FAIL';
export const CREATE_PARTNER_SUCCESS = 'partners/CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_FAIL = 'partners/CREATE_PARTNER_FAIL';
export const UPDATE_PARTNER_SUCCESS = 'partners/UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_FAIL = 'partners/UPDATE_PARTNER_FAIL';
export const DELETE_PARTNER_SUCCESS = 'partners/DELETE_PARTNER_SUCCESS';
export const DELETE_PARTNER_FAIL = 'partners/DELETE_PARTNER_FAIL';
export const CHECK_PARTNER_DOMAIN_SUCCESS = 'partners/CHECK_PARTNER_DOMAIN_SUCCESS';
export const CHECK_PARTNER_DOMAIN_FAIL = 'partners/CHECK_PARTNER_DOMAIN_FAIL';

export const SET_LOGO_FAIL = 'partners/SET_LOGO_FAIL';
export const SET_LOGO_SUCCESS = 'partners/SET_LOGO_SUCCESS';
export const GET_LOGO_FAIL = 'partners/GET_LOGO_FAIL';
export const GET_LOGO_SUCCESS = 'partners/GET_LOGO_SUCCESS';

// константы контактов партнёра удалены — блок целиком на MobX (partnerContactStore)

// блок привязка страховых  к партнёрам (с какой страховой может работать партнёр ? )
export const FETCH_PARTNER_INSURANCE = 'partners/FETCH_PARTNER_INSURANCE';
export const FETCH_PARTNER_INSURANCE_SUCCESS = 'partners/FETCH_PARTNER_INSURANCE_SUCCESS';
export const FETCH_PARTNER_INSURANCE_FAIL = 'partners/FETCH_PARTNER_INSURANCE_FAIL';
export const CREATE_PARTNER_INSURANCE_SUCCESS = 'partners/CREATE_PARTNER_INSURANCE_SUCCESS';
export const CREATE_PARTNER_INSURANCE_FAIL = 'partners/CREATE_PARTNER_INSURANCE_FAIL';
export const DELETE_PARTNER_INSURANCE_SUCCESS = 'partners/DELETE_PARTNER_INSURANCE_SUCCESS';
export const DELETE_PARTNER_INSURANCE_FAIL = 'partners/DELETE_PARTNER_INSURANCE_FAIL';
export const CLEAR_PARTNER_INSURANCE = 'partners/CLEAR_PARTNER_INSURANCE';

export const UPDATE_PARTNER_INSURANCE_SUCCESS = 'partners/UPDATE_PARTNER_INSURANCE_SUCCESS';
export const UPDATE_PARTNER_INSURANCE_FAIL = 'partners/UPDATE_PARTNER_INSURANCE_FAIL';

//  блок Управления привязками корп. клиентов, партнеров-исполнителей и сервисов
